<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8" />

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">

            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">
                      {{this.id ? this.model.name : 'New League'}}
                    </h3>
                  </div>
                  <div class="col-4 text-right">
                    <base-button
                      size="sm"
                      type="danger"
                      @click="modals.discardConfirm = true"
                    >
                      Discard Changes
                    </base-button>
                    <base-button
                      size="sm"
                      type="info"
                      @click="saveChanges"
                    >
                      Save Changes
                    </base-button>
                  </div>
              </div>
            </div>

            <template>
              <form @submit.prevent>
                <h6 class="heading-small text-muted mb-4">League Information</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Name"
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        v-model="model.name"
                        :error="errors.name"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div :class="['form-group', {'has-danger': errors.type}]">
                        <label class="form-control-label">
                          League Type
                        </label>
                        <base-radio name="individual_flex" class="mb-3" v-model="model.type">
                          Individual Flex
                        </base-radio>
                        <base-radio name="team_live" class="mb-3" v-model="model.type">
                          Team Live
                        </base-radio>
                        <base-radio name="mixed" class="mb-3" v-model="model.type">
                          Mixed
                        </base-radio>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block;"
                          v-if="errors.type"
                        >
                            {{ errors.type }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Public
                      </label><br />
                      <base-switch v-model="model.public"></base-switch>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <base-input
                        alternative=""
                        label="Days After Start to Close"
                        placeholder="X Days"
                        input-classes="form-control-alternative"
                        v-model="model.daysOpen"
                        :error="errors.daysOpen"
                        type="number"
                      />
                    </div>
                    <div class="col-lg-4">
                      <base-input
                        alternative=""
                        label="Extra Days After Start to Close"
                        placeholder="X Days"
                        input-classes="form-control-alternative"
                        v-model="model.extraDaysOpen"
                        :error="errors.extraDaysOpen"
                        type="number"
                      />
                    </div>
                    <div class="col-lg-4">
                      <base-input
                        alternative=""
                        label="Number of Scores To Count"
                        placeholder="eg. 15"
                        input-classes="form-control-alternative"
                        v-model="model.numberOfScoresToCount"
                        :error="errors.numberOfScoresToCount"
                        type="number"
                        v-if="model.type === 'mixed' || model.type === 'individual_flex'"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        CTP Award
                      </label><br />
                      <base-switch v-model="model.showCTP"></base-switch>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        LD Award
                      </label><br />
                      <base-switch v-model="model.showLD"></base-switch>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Discretionary Award
                      </label><br />
                      <base-switch v-model="model.showDA"></base-switch>
                    </div>
                  </div>
                </div>

                <h6
                  class="heading-small text-muted mb-4"
                  v-if="model.type === 'team_live'"
                >
                  Divisions
                </h6>
                <div class="pl-lg-4" v-if="model.type === 'team_live'">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-control-label" v-if="model.divisions.length > 0">
                        Divisions
                      </label>
                    </div>
                    <div class="col-12 d-flex flex-wrap">
                      <Chip
                        class="division-chips"
                        v-for="(division, index) in model.divisions"
                        @onDelete="markDivisionForRemoval(index)"
                        :key="division.id+division.name"
                      >
                        {{division.name}}
                      </Chip>
                    </div>
                  </div>
                  <div class="row d-flex align-items-end">
                    <div class="col-8">
                      <base-input
                        label="New Division Name"
                        alternative=""
                        input-classes="form-control-alternative"
                        v-model="model.newDivision"
                        :error="errors.newDivision"
                      />
                    </div>
                    <div class="col-4">
                      <base-button
                        type="info"
                        @click="addDivision"
                        class="mb-4"
                      >
                        Add Division
                      </base-button>
                    </div>
                  </div>
                </div>

                <h6 class="heading-small text-muted mb-4">Schedule</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Start Date"
                        alternative=""
                        :error="errors.startDate"
                      >
                        <flat-picker
                          slot-scope="{focus, blur}"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{allowInput: true}"
                          class="form-control form-control-alternative datepicker"
                          v-model="model.startDate"
                          placeholder="YYYY-MM-DD"
                        />
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Number Of Weeks"
                        alternative=""
                        input-classes="form-control-alternative"
                        type="number"
                        v-model="model.numberOfWeeks"
                        :error="errors.numberOfWeeks"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">
                      <base-button
                        size="sm"
                        type="warning"
                        @click="model.weeks.length > 0
                          ? modals.generateWarning = true : generateWeeks()"
                      >
                        Generate Weeks
                      </base-button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-9">
                      <br />
                      <label class="form-control-label">
                        Weeks
                      </label>
                    </div>
                  </div>

                  <draggable v-model="model.weeks">
                    <WeekFieldGroup
                      v-for="(week, index) in model.weeks"
                      :key="week.startDate.toString() + week.course"
                      :weekNumber="index+1"
                      v-model="model.weeks[index]"
                      :courses="courses"
                      @delete="deleteWeek(index)"
                      :isTeam="model.type === 'team_live'"
                      :isFlex="model.type === 'mixed' || model.type === 'individual_flex'"
                    />
                  </draggable>

                  <div class="row">
                    <div class="col-lg-3">
                      <base-button
                        size="sm"
                        type="success"
                        icon="ni ni-fat-add"
                        @click="addWeek"
                      >
                        Add Week
                      </base-button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-right">
                      <base-button
                        type="info"
                        @click="saveChanges"
                      >
                        Save Changes
                      </base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.generateWarning"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>This will overwrite all previously set weeks.</p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="modals.generateWarning = false; generateWeeks();"
        >
          Go for it
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.generateWarning = false"
        >
          Back to Safety
        </base-button>
      </template>
    </modal>

    <modal
      :show.sync="modals.discardConfirm"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>This will discard all of your changes.</p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="discardChanges"
        >
          Discard
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.discardConfirm = false"
        >
          Stay
        </base-button>
      </template>
    </modal>


  </div>
</template>
<script>
import flatPicker from 'vue-flatpickr-component';
import draggable from 'vuedraggable';
import moment from 'moment';
import WeekFieldGroup from '@/components/WeekFieldGroup.vue';
import Chip from '@/components/Chip.vue';
import 'flatpickr/dist/flatpickr.css';
import ErrorHandler from '@/helpers/AuthError';

export default {
  components: {
    flatPicker,
    draggable,
    WeekFieldGroup,
    Chip,
  },
  props: {
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      leagueId: this.id,
      weeksToDelete: [],
      blankWeek: {
        startDate: '',
        course: '',
        major: false,
        groupPlayoff: false,
        livePlayoff: false,
        movingWeek: false,
        scoreMultiplier: 1.0,
      },
      courses: [],
      modals: {
        generateWarning: false,
        discardConfirm: false,
      },
      model: {
        name: '',
        type: '',
        public: true,
        startDate: '',
        numberOfWeeks: 0,
        weeks: [],
        divisions: [],
        newDivision: '',
        daysOpen: 7,
        extraDaysOpen: 7,
        playoffSingleLongDriveWinner: false,
        showDA: false,
        showCTP: true,
        showLD: true,
        numberOfScoresToCount: 15,
      },
      errors: {
        name: '',
        type: '',
        public: '',
        playoffSingleLongDriveWinner: '',
        startDate: '',
        numberOfWeeks: '',
        newDivision: '',
        daysOpen: '',
        extraDaysOpen: '',
        showDA: '',
        showCTP: '',
        showLD: '',
        numberOfScoresToCount: '',
      },
      divisionsToDelete: [],
    };
  },
  mounted() {
    this.getCourses()
      .then(() => {
        if (this.id) {
          this.getLeague();
        }
      });
  },
  methods: {
    addDivision() {
      if (this.model.newDivision === '') {
        this.errors.newDivision = 'Division name is required';
        return;
      }
      this.errors.newDivision = '';

      this.model.divisions.push({
        id: '',
        name: this.model.newDivision,
      });

      this.model.newDivision = '';
    },
    markDivisionForRemoval(index) {
      this.divisionsToDelete.push(this.model.divisions.splice(index, 1));
    },
    saveDivisions() {
      const saveDivisionJobs = [];
      this.model.divisions.forEach((div) => {
        if (div.id === '') {
          saveDivisionJobs.push(this.createDivision(div));
        }
      });
      this.divisionsToDelete.forEach((div) => {
        if (div.id === '') {
          saveDivisionJobs.push(this.removeDivision(div));
        }
      });
      return Promise.all(saveDivisionJobs);
    },
    createDivision(div) {
      const newDiv = {
        name: div.name,
        league: this.leagueId,
      };
      return this.axios
        .post('/divisions', newDiv, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    removeDivision(div) {
      return this.axios
        .delete(`/divisions/${div.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    saveChanges() {
      if (this.id) {
        this.updateLeague();
      } else {
        this.createLeague();
      }
    },
    discardChanges() {
      this.modals.discardConfirm = false;
      if (this.id) {
        this.$router.push({ name: 'view league', params: { id: this.id } });
      } else {
        this.$router.push({ name: 'leagues' });
      }
    },
    getLeague() {
      this.axios
        .get(`/leagues/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.model.name = response.data.Name;
          this.model.type = response.data.type;
          this.model.public = response.data.public;
          this.model.playoffSingleLongDriveWinner = response.data.playoffSingleLongDriveWinner;
          this.model.showLD = response.data.showLD;
          this.model.showCTP = response.data.showCTP;
          this.model.showDA = response.data.showDA;
          this.model.divisions = response.data.divisions;
          this.model.daysOpen = response.data.daysOpen;
          this.model.extraDaysOpen = response.data.extraDaysOpen;
          this.model.numberOfScoresToCount = response.data.numberOfScoresToCount;
          const weeks = [];
          response.data.weeks
            .sort((a, b) => a.WeekNumber - b.WeekNumber)
            .forEach((week) => {
              console.log({ num: week.WeekNumber, mult: week.scoreMultiplier ? week.scoreMultiplier : 1.0 });
              weeks.push({
                startDate: week.Start,
                course: this.findCourse(week.course),
                major: week.Major,
                groupPlayoff: week.groupPlayoff,
                livePlayoff: week.livePlayoff,
                movingWeek: week.movingWeek,
                id: week.id,
                scoreMultiplier: week.scoreMultiplier ? week.scoreMultiplier : 1.0,
              });
            });
          console.log(weeks);
          this.model.weeks = weeks;
          this.model.numberOfWeeks = weeks.length;
          this.model.startDate = weeks[0].startDate;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    findCourse(id) {
      let match = null;
      this.courses.forEach((course) => {
        console.log(course.id, id);
        if (course.id === id) {
          match = course;
        }
      });
      return match;
    },
    getCourses() {
      return this.axios
        .get('/courses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.courses = response.data;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    createWeek(week) {
      return this.axios
        .post('/weeks', week, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    updateWeek(id, week) {
      return this.axios
        .put(`/weeks/${id}`, week, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    removeWeek(id) {
      return this.axios
        .delete(`/weeks/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    createLeague() {
      this.checkForErrors();
      let isOk = true;
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (isOk) {
        // Submit data

        const newWeeks = [];
        this.model.weeks.forEach((week, index) => {
          newWeeks.push(
            this.createWeek({
              Start: week.startDate,
              course: week.course.id,
              Major: week.major,
              groupPlayoff: week.groupPlayoff,
              livePlayoff: week.livePlayoff,
              movingWeek: week.movingWeek,
              WeekNumber: index + 1,
              scoreMultiplier: week.scoreMultiplier,
            }),
          );
        });

        Promise.all(newWeeks)
          .then((weeks) => {
            const newLeague = {
              Name: this.model.name,
              type: this.model.type,
              public: this.model.public,
              playoffSingleLongDriveWinner: this.model.playoffSingleLongDriveWinner,
              showLD: this.model.showLD,
              showCTP: this.model.showCTP,
              showDA: this.model.showDA,
              daysOpen: parseInt(this.model.daysOpen, 10),
              extraDaysOpen: parseInt(this.model.extraDaysOpe, 10),
              numberOfScoresToCount: parseInt(this.model.numberOfScoresToCount, 10),
              weeks,
            };

            return this.axios
              .post('/leagues', newLeague, {
                headers: {
                  Authorization: `Bearer ${this.$store.state.authToken}`,
                },
              });
          })
          .then((response) => {
            this.leagueId = response.data.id;
            return this.saveDivisions();
          })
          .then((response) => {
            console.log(response);
            // Return to leagues view
            console.log(this.leagueId);
            this.$router.push({ name: 'view league', params: { id: this.leagueId } });
          });
      }
    },
    updateLeague() {
      // delete old weeks
      const deleteJobs = [];
      this.weeksToDelete.forEach((id) => {
        deleteJobs.push(this.removeWeek(id));
      });

      // update existing weeks
      const updateAndCreateJobs = [];
      this.model.weeks.forEach((week, index) => {
        if (week.id) {
          // update
          updateAndCreateJobs.push(
            this.updateWeek(week.id, {
              Start: week.startDate,
              course: week.course ? week.course.id : null,
              Major: week.major,
              groupPlayoff: week.groupPlayoff,
              livePlayoff: week.livePlayoff,
              movingWeek: week.movingWeek,
              WeekNumber: index + 1,
              scoreMultiplier: week.scoreMultiplier,
            }),
          );
        } else {
          // create
          updateAndCreateJobs.push(
            this.createWeek({
              Start: week.startDate,
              course: week.course.id,
              Major: week.major,
              groupPlayoff: week.groupPlayoff,
              livePlayoff: week.livePlayoff,
              movingWeek: week.movingWeek,
              WeekNumber: index + 1,
              scoreMultiplier: week.scoreMultiplier,
            }),
          );
        }
      });

      Promise.all(deleteJobs)
        .then(() => {
          this.weeksToDelete = [];
          return Promise.all(updateAndCreateJobs);
        })
        .then((weeks) => {
          const league = {
            Name: this.model.name,
            type: this.model.type,
            public: this.model.public,
            playoffSingleLongDriveWinner: this.model.playoffSingleLongDriveWinner,
            showCTP: this.model.showCTP,
            showLD: this.model.showLD,
            showDA: this.model.showDA,
            daysOpen: parseInt(this.model.daysOpen, 10),
            extraDaysOpen: parseInt(this.model.extraDaysOpen, 10),
            numberOfScoresToCount: parseInt(this.model.numberOfScoresToCount, 10),
            weeks,
          };

          return this.axios
            .put(`/leagues/${this.id}`, league, {
              headers: {
                Authorization: `Bearer ${this.$store.state.authToken}`,
              },
            });
        })
        .then((response) => {
          console.log(response.data);
          this.leagueId = response.data.id;
          return this.saveDivisions();
        })
        .then((response) => {
          console.log(response.data);
          console.log(this.leagueId);
          this.$router.push({ name: 'view league', params: { id: this.leagueId } });
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });

      // update league
    },
    checkForErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });

      const requiredString = 'This field is required';
      if (this.model.name === '') {
        this.errors.name = requiredString;
      }
      if (this.model.type === '') {
        this.errors.type = requiredString;
      }
      if (this.model.startDate === '') {
        this.errors.startDate = requiredString;
      }
      if (this.model.numberOfWeeks <= 0) {
        this.errors.numberOfWeeks = 'This field must be greater than 0';
      }
      if (this.model.daysOpen === '' || this.model.daysOpen <= 0) {
        this.errors.daysOpen = 'This field must be greater than 0';
      }
      if (this.model.extraDaysOpen === '' || this.model.extraDaysOpen < 0) {
        this.errors.daysOpen = 'This field must be greater than or equal to 0';
      }
      if (this.model.numberOfScoresToCount === '' || parseInt(this.model.numberOfScoresToCount, 10) <= 0) {
        this.errors.numberOfScoresToCount = 'This field must be greater than 0';
      }
    },
    generateWeeks() {
      console.log('Generating Weeks');
      if (this.model.startDate === '') {
        this.errors.startDate = 'This field is required';
        return;
      }
      if (this.model.numberOfWeeks <= 0) {
        this.errors.numberOfWeeks = 'This field is required';
        return;
      }

      this.model.weeks.forEach((week) => {
        if (week.id) {
          this.weeksToDelete.push(week.id);
        }
      });

      const newWeeksArray = [];

      for (let i = 0; i < this.model.numberOfWeeks; i += 1) {
        const newWeek = { ...this.blankWeek };
        newWeek.startDate = moment(this.model.startDate).add(7 * i, 'days').toDate();
        newWeeksArray.push(newWeek);
      }

      this.model.weeks = newWeeksArray;
    },
    addWeek() {
      this.model.weeks.push({
        ...this.blankWeek,
      });

      this.model.numberOfWeeks = this.model.weeks.length;
    },
    deleteWeek(index) {
      if (this.model.weeks[index].id) {
        this.weeksToDelete.push(this.model.weeks[index].id);
      }
      this.model.weeks.splice(index, 1);
      this.model.numberOfWeeks = this.model.weeks.length;
    },
  },
};
</script>
<style lang="scss" scoped>
  .division-chips{
    margin-bottom: 1rem;
    margin-right: 1rem;

    &:last-child{
      margin-right: 0;
    }
  }
</style>
